module.exports = __webpack_public_path__ + "img/ppt.3b7a1df1.jpg";